import React from 'react';

import {isInaccessible as isInaccessibleInfo} from 'graphql-client/InaccessibleInfo';
import ChipPopoverContent from 'ui-library/chips/ChipPopoverContent';

import {TestDefinitionChipGraphQL} from '../../../../../graphql-fragments/procedures/__generated/TestDefinitionChipGraphQL';

interface Props {
  /** Whether the test definition is accessible to the current user */
  isInaccessible: boolean | undefined;
  /** The test definition summary, if we already have it */
  testDefinition?: TestDefinitionChipGraphQL;
}

export function TestDefinitionChipPopoverContent(props: Props): JSX.Element | null {
  const {testDefinition, isInaccessible} = props;

  if (testDefinition == null) {
    return null;
  } else if (isInaccessible) {
    return <>(No access)</>;
  }

  const fields = [
    {label: 'Name', value: testDefinition.name},
    {
      label: 'Result schema',
      value: !isInaccessibleInfo(testDefinition.resultSchemaCorrect)
        ? testDefinition.resultSchemaCorrect.name
        : '(No access)',
    },
    {label: 'Description', value: testDefinition.description},
  ];

  return <ChipPopoverContent info={{fields}} />;
}
